<template>
    <div >
        <div class="updateBox">
        <el-upload
        class="upload-demo"
        action='zw56-zhb-panel-server/zhb_panel/ZhbWebTest/saveDeliver'
        :on-change="handleChange"
        :file-list="fileList">
        <el-button size="small" type="primary">交货单</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <el-upload
        class="upload-demo"
        action="zw56-zhb-panel-server/zhb_panel/ZhbWebTest/saveInventoryStock"
        :on-change="handleChange2"
        :file-list="fileList2">
        <el-button size="small" type="primary">库存</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <el-upload
        class="upload-demo"
        action="zw56-zhb-panel-server/zhb_panel/ZhbWebTest/emptyVehicleWeight"
        :on-change="handleChange3"
        :file-list="fileList3">
        <el-button size="small" type="primary">空车磅</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <!--<el-upload
        class="upload-demo"
        action="zw56-zhb-panel-server/zhb_panel/ZhbWebTest/lockGoods"
        :on-change="handleChange4"
        :file-list="fileList4">
        <el-button size="small" type="primary">锁装</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>-->
        <el-upload
        class="upload-demo"
        action="zw56-zhb-panel-server/zhb_panel/ZhbWebTest/heavyVehicleWeight"
        :on-change="handleChange5"
        :file-list="fileList5">
        <el-button size="small" type="primary">重车磅</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <el-upload
        class="upload-demo"
        action="zw56-zhb-panel-server/zhb_panel/ZhbWebTest/loadDetail"
        :on-change="handleChange6"
        :file-list="fileList6">
        <el-button size="small" type="primary">装车单</el-button>
        <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
        </el-upload>
        <el-upload
        class="upload-demo"
        action="zw56-zhb-panel-server/zhb_panel/i/contract/deliver/impDeliverInfoExcel"
        :on-change="handleChange7"
        :file-list="fileList7">
        <el-button size="small" type="primary">导入交货单</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xlsx文件</div>
        </el-upload>
        </div>
    </div>
</template>
<script>
// import { update } from '@/api/zhb'
export default {
  data () {
    return {
      fileList: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: []
    }
  },
  methods: {
    handleChange (file, fileList) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange2 (file, fileList2) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange3 (file, fileList3) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange4 (file, fileList4) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange5 (file, fileList5) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange6 (file, fileList6) {
      //   this.fileList = fileList.slice(-3)
    },
    handleChange7 (file, fileList7) {
      //   this.fileList = fileList.slice(-3)
    }
  }
}
</script>
<style>
.updateBox{
    margin-left: 15px;
}
</style>
